if (!customElements.get("apply-discount")) {
    customElements.define(
        "apply-discount",
        class ApplyDiscount extends HTMLElement {
            constructor() {
                super();
                this.input = this.querySelector("[data-input]");
                this.button = this.querySelector("[data-apply]");
                this.error = this.querySelector("[data-error]");
                this.usedDiscountCode = this.querySelector("#discount-used");
                this.sectionID = this.dataset.sectionId;
                this.refillButton = this.querySelector("[data-refill]");

                // 绑定点击事件
                this.button.addEventListener("click", this.handleApply.bind(this));
                this.refillButton.addEventListener("click", this.handleRefill.bind(this));

                // 实时监测this.input的值是否为空，执行checkInput方法
                this.input.addEventListener("input", this.checkInput.bind(this));

                // 解析 JSON 数据
                this.discountCodes = [];
                if (this.usedDiscountCode) {
                    try {
                        this.discountCodes = JSON.parse(this.usedDiscountCode.textContent.trim()) || [];
                        // console.log("当前已使用折扣码:", this.discountCodes);
                    } catch (error) {
                        // console.error("JSON 解析失败:", error);
                    }
                }
            }

            connectedCallback() {
                this.checkInput();
            }

            checkInput() {
                // 判断this.input是否为空，若为空，给this.button添加disabled属性
                if (!this.input.value.trim()) {
                    this.button.setAttribute("disabled", "disabled");
                } else {
                    this.button.removeAttribute("disabled");
                }
            }

            handleApply(e) {
                e.preventDefault();
                // console.log("应用折扣");

                this.setButtonState(true); // 禁用按钮，修改样式

                const userDiscount = this.input.value.trim().toUpperCase(); // 获取用户输入的折扣码
                const allDiscounts = [...this.discountCodes, userDiscount].filter(Boolean); // 合并折扣码

                const discountQuery = allDiscounts.length ? `?discount=${allDiscounts.join(",")}` : "";
                const checkoutUrl = `${window.shopUrl}/checkout${discountQuery}`;
                // console.log(`${window.shopUrl}`);
                // console.log("结账链接:", checkoutUrl);

                fetch(checkoutUrl)
                    .then((res) => res.json())
                    .then((result) => {
                        // console.log("请求结果:", result);
                    })
                    .catch((error) => {
                        // console.error("请求失败:", error);
                    })
                    .finally(() => {
                        this.updateCart();
                    });
            }

            updateCart() {
                const updateUrl = `${window.shopUrl}?section_id=${this.sectionID}`;
                // console.log("更新购物车的链接:", updateUrl);
                const updatePart = document.querySelector("#Cart-Drawer .side-panel-inner");

                fetch(updateUrl)
                    .then((res) => res.text())
                    .then((html) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const newContent = doc.querySelector("#Cart-Drawer .side-panel-inner");

                        const userDiscount = this.input.value.trim().toUpperCase();
                        // console.log("用户新输入的折扣码:", userDiscount);

                        const usedDiscountsJSON = this.getUsedDiscounts(newContent);
                        // console.log("当前页面已使用的折扣码列表:", usedDiscountsJSON);

                        // 判断当前输入的折扣码是否在已使用的折扣码列表中
                        if (this.isDiscountUsed(userDiscount)) {
                            // console.log("折扣码已使用");
                            this.showError();
                        } else if (this.isDiscountValid(userDiscount, usedDiscountsJSON)) {
                            // console.log("折扣码有效，更新购物车");
                            this.replaceCartContent(newContent, updatePart);
                        } else {
                            // console.log("折扣码无效，显示错误");
                            this.showError();
                        }
                    })
                    .catch((error) => {
                        // console.error("购物车更新失败:", error);
                    });
            }

            getUsedDiscounts(newContent) {
                const usedDiscountScript = newContent.querySelector("#discount-used");
                return usedDiscountScript ? JSON.parse(usedDiscountScript.textContent.trim()) || [] : [];
            }

            // 判断折扣码是否已经使用
            isDiscountUsed(userDiscount) {
                return this.discountCodes.includes(userDiscount);
            }

            // 判断折扣码是否有效 (即不在已使用的折扣码中，且在 newContent 中找到)
            isDiscountValid(userDiscount, usedDiscountsJSON) {
                return userDiscount && !this.discountCodes.includes(userDiscount) && usedDiscountsJSON.includes(userDiscount);
            }

            showError() {
                this.classList.add("show_error");
                this.setButtonState(false);
                setTimeout(() => {
                    this.classList.remove("show_error");
                }, 5000);
            }

            setButtonState(isDisabled) {
                if (isDisabled) {
                    this.button.setAttribute("disabled", "");
                    this.style.opacity = 0.5;
                } else {
                    this.button.removeAttribute("disabled");
                    this.style.opacity = 1;
                }
            }

            replaceCartContent(newContent, updatePart) {
                // this.dispatchEvent(new CustomEvent("discountUpdated"));
                if (newContent) {
                    updatePart.replaceWith(newContent);
                } else {
                    // console.error("更新购物车失败: 无法找到目标部分");
                }
            }

            handleRefill() {
                // console.log("Click refill");
                this.classList.remove('show_content');
            }
        }
    );
}


if (!customElements.get("apply-discount-code")) {
    customElements.define(
        "apply-discount-code",
        class ApplyDiscountCode extends HTMLElement {
            constructor() {
                super();
                this.wrapper = this.querySelector(".product__coupon__wrapper");
                this.sectionID = this.dataset.sectionId;
                this.usedDiscountCode = this.querySelector("#product-info-discount-used");
                this.discountCode = this.dataset.discountCode?.trim() || "";
                this.buttonLabel = this.querySelector('.product__coupon__button__text');
                this.successLabel = this.querySelector('.product__coupon__button__success_text');
                // 解析 JSON 数据
                // this.discountCodes = [];
                // if (this.usedDiscountCode) {
                //     try {
                //         this.discountCodes = JSON.parse(this.usedDiscountCode.textContent.trim()) || [];
                //         // console.log("当前已使用折扣码:", this.discountCodes);
                //     } catch (error) {
                //         // console.error("JSON 解析失败:", error);
                //     }

                //     if (this.wrapper) {
                //         this.wrapper.addEventListener("click", this.handleClick.bind(this));
                //     }
                // }
                // 监听自定义事件 "discountUpdated"
                // this.addEventListener("discountUpdated", this.handleDiscountUpdated.bind(this));
            }

            connectedCallback() {
                this.wrapper.addEventListener("click", this.throttle(this.copyCode.bind(this), 1000));
            }

            copyCode() {
                navigator.clipboard.writeText(this.discountCode).then(() => {
                    this.wrapper.classList.add("success");
                }).finally(() => {
                    setTimeout(() => {
                        this.wrapper.classList.remove("success");
                    }, 3000);
                });
            }

            throttle(func, delay) {
                let lastCall = 0;
                return (...args) => {
                    const now = Date.now();
                    if (now - lastCall < delay) {
                        return;
                    }
                    lastCall = now;
                    func.apply(this, args);
                };
            }

            handleDiscountUpdated() {
                // const updateUrl = `${window.shopUrl}?section_id=${this.sectionID}`;
                const updateUrl = `${window.shopUrl}`;
                // const updatePart = this.usedDiscountCode;
                const updatePartCartdrawer = document.querySelector("#Cart-Drawer .side-panel-inner");
                fetch(updateUrl)
                    .then((res) => res.text())
                    .then((html) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        // const newContent = doc.querySelector("#product-info-discount-used");
                        const newContentCart = doc.querySelector("#Cart-Drawer .side-panel-inner");
                        // this.replaceCartContent(newContent, updatePart);
                        this.replaceCartContent(newContentCart, updatePartCartdrawer);
                    })
            }

            handleClick(e) {
                e.preventDefault();

                if (!this.discountCode) {
                    console.error("未找到有效的折扣码 data-discount-code");
                    this.showError();
                    return;
                }

                // 应用折扣
                this.applyDiscountCode(this.discountCode);
            }

            applyDiscountCode(discount) {
                this.setButtonState(true);

                const allDiscounts = [...this.discountCodes, discount].filter(Boolean);
                const discountQuery = allDiscounts.length ? `?discount=${allDiscounts.join(",")}` : "";
                const checkoutUrl = `${window.shopUrl}/checkout${discountQuery}`;

                fetch(checkoutUrl)
                    .then((res) => res.json())
                    .then((result) => {
                        // console.log("请求结果:", result);
                    })
                    .catch((error) => {
                        // console.error("请求失败:", error);
                    })
                    .finally(() => {
                        this.updateCart();
                    });
            }

            setButtonState(isDisabled) {
                this.wrapper.classList.toggle("loading", isDisabled);
            }

            setButtonSuccess() {
                this.wrapper.classList.add("success");
                setTimeout(() => {
                    this.wrapper.classList.remove("success");
                }, 3000);
            }

            updateCart() {
                const updateUrl = `${window.shopUrl}?section_id=${this.sectionID}`;
                // console.log("更新购物车的链接:", updateUrl);
                const updatePart = this.usedDiscountCode;

                fetch(updateUrl)
                    .then((res) => res.text())
                    .then((html) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const newContent = doc.querySelector("#product-info-discount-used");

                        // console.log("用户新应用的折扣码:", this.discountCode);
                        // console.log("新页面的折扣码元素:", newContent);
                        const usedDiscountsJSON = this.getUsedDiscounts(newContent);
                        // console.log("当前页面已使用的折扣码列表:", usedDiscountsJSON);

                        // 判断当前输入的折扣码是否在已使用的折扣码列表中
                        if (this.isDiscountUsed(this.discountCode)) {
                            // console.log("折扣码已使用");
                            this.showError();
                        } else if (this.isDiscountValid(this.discountCode, usedDiscountsJSON)) {
                            // console.log("折扣码有效，更新购物车");
                            this.replaceCartContent(newContent, updatePart);
                            this.setButtonState(false);
                            this.setButtonSuccess();
                            this.dispatchEvent(new CustomEvent("discountUpdated"));
                        } else {
                            // console.log("折扣码无效，显示错误");
                            this.showError();
                        }
                    })
                    .catch((error) => {
                        // console.error("购物车更新失败:", error);
                    });
            }

            getUsedDiscounts(usedDiscountScript) {
                try {
                    if (!usedDiscountScript) return [];
                    const jsonText = usedDiscountScript.textContent.trim();
                    const data = JSON.parse(jsonText);
                    return Array.isArray(data) ? data : [];
                } catch (error) {
                    console.error("解析 usedDiscountScript JSON 出错：", error);
                    return [];
                }
            }

            // 判断折扣码是否已经使用
            isDiscountUsed(userDiscount) {
                return this.discountCodes.includes(userDiscount);
            }

            // 判断折扣码是否有效 (即不在已使用的折扣码中，且在 newContent 中找到)
            isDiscountValid(userDiscount, usedDiscountsJSON) {
                return userDiscount && !this.discountCodes.includes(userDiscount) && usedDiscountsJSON.includes(userDiscount);
            }

            showError() {
                this.classList.add("show_error");
                this.setButtonState(false);
                setTimeout(() => {
                    this.classList.remove("show_error");
                }, 5000);
            }

            replaceCartContent(newContent, updatePart) {
                // console.log("更新购物车的部分:", updatePart);
                // console.log("新内容:", newContent);
                if (newContent) {
                    updatePart.replaceWith(newContent);
                } else {
                    // console.error("更新购物车失败: 无法找到目标部分");
                }
            }
        }
    );
}
